export const paperclip = `<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 324.923 324.923" style="enable-background:new 0 0 324.923 324.923;" xml:space="preserve">
<path d="M303.265,34.091l-7.897-8.023C281.351,11.825,262.685,3.982,242.81,3.982c-19.994,0-38.803,7.922-52.938,22.284
	L15.652,201.363c-20.814,21.146-20.878,55.492-0.142,76.564l5.46,5.547c10.363,10.529,24.877,16.568,39.818,16.568
	c14.308,0,27.526-5.425,37.22-15.272L254.42,125.848c12.181-12.378,12.214-32.48,0.075-44.812l-2.915-2.964
	c-5.896-5.99-13.749-9.288-22.112-9.287c-8.406,0-16.31,3.328-22.255,9.369L62.641,225.046c-2.324,2.362-2.294,6.161,0.067,8.485
	c2.362,2.324,6.159,2.293,8.485-0.067L215.766,86.572c3.672-3.731,8.538-5.787,13.702-5.787c5.123-0.001,9.938,2.025,13.559,5.703
	l2.914,2.964c7.571,7.691,7.538,20.243-0.074,27.978L89.456,276.352c-7.42,7.538-17.601,11.69-28.667,11.69
	c-11.747,0-23.143-4.733-31.266-12.986l-5.46-5.547c-16.168-16.429-16.104-43.223,0.118-59.704l174.22-175.098
	c11.885-12.076,27.655-18.726,44.408-18.726c16.634,0,32.262,6.571,44.006,18.504l7.897,8.024
	c24.393,24.784,24.298,65.209-0.211,90.111l-175.3,178.112c-2.324,2.362-2.294,6.161,0.067,8.485
	c1.169,1.15,2.689,1.724,4.209,1.724c1.551,0,3.102-0.599,4.276-1.791l175.3-178.112C332.131,111.493,332.225,63.518,303.265,34.091
	z"/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
`
